<template>

  <div :style="mapStyle">
    <!-- removed `style="height: 80%;z-index: 0;"` to enable full-screen-map -->
    <l-map
      v-if="show"
      :zoom="zoom"
      :center="center"
      :max-bounds="maxBounds"
      :options="mapOptions"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @click="addMarker"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <!-- Listed companies -->
      <l-marker v-for="(item,index) in items"  :key="index" :lat-lng="getPosByItem(item)" :icon="icon">
        <l-popup v-if="item">
          <div @click="openShop(item)">
            <b>{{item.title}}</b>
            <p>
              {{item.descr}}
            </p>
            <p>
              <center><img :src="getModifiedImage(item.img)" style="max-width:200px;max-height:100px;"></center>
            </p>
          </div>
        </l-popup>
      </l-marker>

      <!-- Clicked Positions -->
      <l-marker v-if="clickedPosition" :lat-lng="clickedPosition.latlng" :icon="icon"></l-marker>
    </l-map>
  </div>
</template>

<script>
import { latLngBounds,latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import {helper} from '@/mixins/helper.js'

export default {
  name: "RTMap",
  mixins:[helper],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props:{
    show:{
      type:Boolean,
      default:true
    },
    enableInput:{
      type:Boolean,
      default:false
    },
    items:{
      type:Array
    },
    height:{
      type:String,
      default:"500px"
    },
    width:{
      type:String,
      default:"100%"
    },
    initialZoom:{
      type:Number,
      default:13
    }
  },
  data() {
    return {
      zoom: this.initialZoom,
      center: latLng(50.927798, 11.587548),
      url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', //https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      currentCenter: latLng(50.927798, 11.587548),
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 18,
        minZoom:10
      },
      icon: icon({
        iconUrl: "/images/heart.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      }),
      maxBounds: latLngBounds([
        [50.827506, 11.461751],
        [50.990554, 11.684780]
      ]),
      clickedPosition:null
    };
  },
  computed:{
    mapStyle(){
      return `height: ${this.height}; width: ${this.width};`;
    }
  },
  methods: {
    addMarker(e) {
      if(this.enableInput && e){
        this.clickedPosition={latlng: e.latlng};
        this.$emit('updatePosition',e.latlng);
      }
    },
    getPosByItem(item){

      if(item && !isNaN(item.lat) && !isNaN(item.lng)){
        return latLng(Number(item.lat),Number(item.lng))
      }else{
        console.log('Shop without location');
        console.log(item);
      }
      return latLng(0,0);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    openShop(item) {
      if(item){
        this.$router.push({ name: 'shop', params: { id: item.id } })
      }
    }
  },
  mounted(){
    if(this.items && this.items.length==1){
      this.center=latLng(this.items[0].lat,this.items[0].lng)
    }
  }
};
</script>
